
/** CE CODE A ETE GENERE PAR L'IA */
import { COULEURS_MARKER } from "../gestionIcon/iconMarkerConf";

// Calcule la luminance relative (WCAG 2.x)
function getRelativeLuminance(hex) {
  const rgb = hexToRgb(hex);
  const [r, g, b] = [rgb.r, rgb.g, rgb.b].map(v => {
    v /= 255;
    return v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/**
 * Convertit un hex (#RRGGBB ou #RGB) en { r, g, b }
 */
function hexToRgb(hex) {
  let h = hex.replace(/^#/, '');

  // Supporte le format court #RGB → #RRGGBB
  if (h.length === 3) {
    h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  }

  if (h.length !== 6) {
    throw new Error(`Couleur hex invalide : "${hex}"`);
  }

  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
  };
}

/**
 * Distance euclidienne au carré entre deux couleurs RGB.
 * (On évite Math.sqrt inutile puisqu'on compare uniquement les distances.)
 */
function colorDistanceSq(a, b) {
  return (
    (a.r - b.r) ** 2 +
    (a.g - b.g) ** 2 +
    (a.b - b.b) ** 2
  );
}

// Retourne "white" ou "black" selon le contraste WCAG
export default function getTextColor(bgHex) {
  if (!bgHex) return 'black'; // défaut si pas de couleur

  const L  = getRelativeLuminance(bgHex);
  const Lw = 1;   // luminance du blanc
  const Lb = 0;   // luminance du noir

  const contrastWhite = (Lw + 0.05) / (L  + 0.05);
  const contrastBlack = (L  + 0.05) / (Lb + 0.05);

  return contrastWhite >= contrastBlack ? "white" : "black";
}

/**
 * Retourne la couleur de COULEURS_MARKER la plus proche de `inputHex`.
 *
 * @param {string} inputHex  - Ex: "#AB149E" ou "#a4f"
 * @returns {{ hex: string, id: number }}
 *   - hex : la couleur la plus proche (ex: "#ab149e")
 *   - id  : son identifiant dans COULEURS_MARKER
 */
export function closestMarkerColor(inputHex) {
  const input = hexToRgb(inputHex);

  let bestHex  = null;
  let bestId   = null;
  let bestDist = Infinity;

  for (const [hex, id] of Object.entries(COULEURS_MARKER)) {
    const dist = colorDistanceSq(input, hexToRgb(hex));

    if (dist < bestDist) {
      bestDist = dist;
      bestHex  = hex;
      bestId   = id;
    }

    // Correspondance exacte → pas besoin de continuer
    if (dist === 0) break;
  }

  return { hex: bestHex, id: bestId };
}
